import { inject, Injectable, Injector } from '@angular/core';
import { TimeReport } from '@app/shared/types/models/reports/time-report';
import { AbsenceReportDTO } from '../../dtos/reports/absence-report.dto';
import { TimeReportDTO } from '../../dtos/reports/time-report.dto';
import { WorkTimeReportDTO } from '../../dtos/reports/work-time-report.dto';
import { AbstractFactory } from '../abstract.factory';
import { AbsenceReportFactory } from './absence-report.factory';
import { WorkTimeReportFactory } from './work-time-report.factory';

@Injectable({ providedIn: 'root' })
export class TimeReportFactory extends AbstractFactory<TimeReportDTO, TimeReport> {
  private readonly injector: Injector = inject(Injector);
  private readonly workTimeReportFactory = this.injector.get(WorkTimeReportFactory);
  private readonly absenceReportFactory = this.injector.get(AbsenceReportFactory);

  public constructor() {
    super();
  }

  public produce(item: TimeReportDTO): TimeReport {
    if (item.type === 'AbsenceReport' || this.isAbsenceDto(item)) {
      return this.absenceReportFactory.produce(item as AbsenceReportDTO);
    }

    if (item.type === 'WorkTimeReport' || this.isWorkTimeDto(item)) {
      return this.workTimeReportFactory.produce(item as WorkTimeReportDTO);
    }

    throw Error('Unrecognized Report type');
  }

  private isAbsenceDto(item: TimeReportDTO): boolean {
    return 'absenceType' in item && !!(item as AbsenceReportDTO).absenceType;
  }

  private isWorkTimeDto(item: TimeReportDTO): boolean {
    return 'hoursType' in item || 'taskId' in item;
  }
}
